import React from 'react'
import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

export {
  SectionHeading,
  Heading,
  End,
} from './GridView.css'

export const Container = styled(Box)`
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  margin: 0px;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    flex-direction: row;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    margin-bottom: ${props => props.theme.global.edgeSize.medium};
  }
`

export const Style = () => (
  <style>
    {`
    .tree{
      margin:1em;
      background:#fff;
      padding:20px 0 20px 30px;
      list-style-type:none;
      color:#333;
    }
    .tree input{
      position:absolute;
      clip:rect(0,0,0,0)
    }
    .tree input~ul{
      display:none;
      list-style-type:none;
    }
    .tree input:checked~ul{
      display:block;
      list-style-type:none;
    }
    .tree li{
      position:relative;
      padding:0 0 1em 1em;
    }
    #tree_root{
      color:#05629b;
      font-weight:700;
    }
    .tree ul li{
      padding:.5em 0 0 1em;
      font-size:14px;
      color:#333;
    }
    .tree>li:last-child{
      padding-bottom:0px;
    }
    .tree_label{
      position:relative;
      display:block;
      background:#fff;
    }
    label.tree_label{
      cursor:pointer;
      font-size:14px;
      color:#333
    }
    label.tree_label:hover{
      color:#666
    }
    label.tree_label:before{
      color:#333;
      position:relative;
      z-index:1;
      float:left;
      margin:0 14px 0 -34px;
      width:1em;
      height:1em;
      border-radius:1em;
      content:'+';
      text-align:center;
      font-size:28px;
      font-weight:500;
    }
    :checked~label.tree_label:before{
      content:'–';
    }
    .tree li:before{
      position:absolute;
      top:0;
      bottom:0;
      left:-.5em;
      display:block;
      width:0;
      border-left:1px solid #cccaca;
      content:'';
    }
    .tree_label:after{
      position:absolute;
      top:0;
      left:-1.5em;
      display:block;
      height:.5em;
      width:1em;
      border-bottom:1px solid #cccaca;
      border-left:1px solid #cccaca;
      content:'';
    }
    label.tree_label:after{
      border-bottom:0px;
    }
    :checked~label.tree_label:after{
      border-bottom:1px solid #cccaca;
      top:18px;
    }

    .tree li:last-child:before,
    ul.subcat > li:before {
      height:1em;
      bottom:auto;
    }
    .tree>li:last-child:before{
      display:none;
    }
    .tree_custom{
      display:block;
      background:#eee;
      padding:1em;
      border-radius:.3em;
    }
    span.tree_label.link{
      color:#05629B;
      cursor:pointer;
    }

  `}
  </style>
)

export default {
  Style,
  Container,
}
